
    import { apiClient } from '/assets/js/api-client.js';
    import { initAuth } from '/assets/js/auth-middleware.js';
    import { CONFIG, DERIVED_CONFIG } from '/assets/js/config.js';
    
    // Initialize auth
    document.addEventListener('DOMContentLoaded', async () => {
        // If already authenticated, redirect to docs
        if (await apiClient.isAuthenticated()) {
            window.location.href = '/docs/';
            return;
        }
        
        // Set up login form
        const loginForm = document.getElementById('login-form');
        if (loginForm) {
            loginForm.addEventListener('submit', async (e) => {
                e.preventDefault();
                const email = document.getElementById('email').value;
                const password = document.getElementById('password').value;
                const errorElement = document.getElementById('error-message');
                
                try {
                    // Show loading state
                    const submitBtn = loginForm.querySelector('button[type="submit"]');
                    const originalBtnText = submitBtn.innerHTML;
                    submitBtn.disabled = true;
                    submitBtn.innerHTML = 'Signing in...';
                    
                    // Perform login
                    await apiClient.login({ email, password });
                    
                    // Redirect will be handled by the auth middleware
                    const redirectUrl = sessionStorage.getItem('redirectAfterLogin') || '/docs/';
                    window.location.href = redirectUrl;
                    
                } catch (error) {
                    if (errorElement) {
                        errorElement.textContent = error.message || 'Login failed. Please check your credentials and try again.';
                        errorElement.style.display = 'block';
                    }
                } finally {
                    // Reset button state
                    const submitBtn = loginForm.querySelector('button[type="submit"]');
                    if (submitBtn) {
                        submitBtn.disabled = false;
                        submitBtn.innerHTML = originalBtnText;
                    }
                }
            });
        }
    });

    // Token access functionality
    let isLoading = false;

    function setLoading(state) {
        const btn = document.getElementById('submitBtn');
        const btnText = btn.querySelector('.btn-text');

        if (state) {
            isLoading = true;
            btn.disabled = true;
            btn.innerHTML = '<div class="loading"></div> Authenticating...';
            document.getElementById('errorMessage').style.display = 'none';
        } else {
            isLoading = false;
            btn.disabled = false;
            btn.innerHTML = '<span class="btn-text">Access Documentation</span>';
        }
    }

    async function accessDocs() {
        if (isLoading) return;

        const token = document.getElementById('tokenInput').value.trim();
        const errorMessage = document.getElementById('errorMessage');

        if (!token) {
            errorMessage.textContent = 'Please enter your access token';
            errorMessage.style.display = 'block';
            document.getElementById('tokenInput').focus();
            return;
        }

        setLoading(true);

        try {
            // Validate token with the backend endpoint
            const response = await fetch(DERIVED_CONFIG.ENDPOINTS.VALIDATE_TOKEN, {
                method: 'GET',
                headers: {
                    'Authorization': `Bearer ${token}`,
                    'Content-Type': 'application/json',
                    'X-App-Unique-Id': CONFIG.APP_UNIQUE_ID
                }
            });

            if (!response.ok) {
                if (response.status === 401) {
                    throw new Error('Unauthorized Access. Please contact developers@q2qtechnologies.com for access.');
                } else {
                    throw new Error('Invalid token. Please check your access token and try again. If the problem persists, contact developers@q2qtechnologies.com for support.');
                }
            }

            const result = await response.json();
            
            if (result.status !== 'success') {
                throw new Error(result.message || 'Token validation failed');
            }

            // Store token in localStorage
            localStorage.setItem(CONFIG.TOKEN_STORAGE_KEY, token);
            
            // Redirect to docs
            window.location.href = '/docs/';

        } catch (error) {
            errorMessage.textContent = error.message || 'Invalid token. Please try again.';
            errorMessage.style.display = 'block';
            setLoading(false);
        }
    }

    // Handle Enter key in token input
    document.getElementById('tokenInput').addEventListener('keypress', function(e) {
        if (e.key === 'Enter') {
            accessDocs();
        }
    });

    // Focus token input on load
    const tokenInput = document.getElementById('tokenInput');
    if (tokenInput) {
        tokenInput.focus();
    }

    // Expose accessDocs to global scope for form submit handler
    window.accessDocs = accessDocs;
    
    // Also add a fallback for immediate access
    window.accessDocsFallback = function() {
        if (typeof window.accessDocs === 'function') {
            return window.accessDocs();
        }
        console.error('accessDocs function not yet loaded');
        return false;
    };
